import Button from '@eduzz/houston-ui/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { enableMelhorEnvioAuth, getDeliveryIntegrationActiveList } from 'store/Orbita/Product/actions';

import type { Dispatch } from 'react-redux';

type FreightVinculationProps = {
  dispatch: Dispatch<any>;
};

const useStyles = makeStyles((theme) => ({
  root: theme.mixins.gutters({
    textAlign: 'center',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    '& h1': {
      fontSize: '2.5rem',
      lineHeight: '1.5rem',
      fontWeight: 600,
      color: '#596375',
    },
    '& h2': {
      fontSize: '1rem',
      color: '#596375',
    },
  }),
}));

const FreightVinculation = ({ dispatch }: FreightVinculationProps) => {
  const classes = useStyles();

  const closeTab = React.useCallback(() => {
    const params = new URL(document.location.href).searchParams;
    const melhorEnvioCode = params.get('code');
    dispatch(enableMelhorEnvioAuth(melhorEnvioCode));
    dispatch(getDeliveryIntegrationActiveList());
    window.opener.handleCloseMelhorEnvioPopup();
    window.close();
  }, [dispatch]);

  return (
    <div className={classes.root}>
      <div className='notfound'>
        <h1>Vinculado com sucesso</h1>
        <br />
        <h2>Conta vinculada ao Melhor Envio</h2>
        <br />
      </div>
      <Button onClick={closeTab}>Ok</Button>
    </div>
  );
};

export default connect()(FreightVinculation);
